<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--		-->
	<!-- Info	-->
	<!--		-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="main-group-title">{{ ItemCount }} Item(s) Selected</label>
		</div>
	</div>

	<!--			 -->
	<!-- Info (FYI)  -->
	<!--	 		 -->
	<div class="main-group-item" style="margin-top: 0px">
		<div class="main-group-item-center-padding">
			<label class="main-group-info"
				>Note: All {{ ItemCount }} item(s) will have their status changed to the selected status. They will all get the same comment if one is entered.
				If no comment is entered, than the current comment will be unchanged.</label
			>
		</div>
	</div>

	<!-- 			   		  -->
	<!-- PrintReason Selector -->
	<!-- 					  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Status</label>
			</div>

			<div style="margin-left: 10px; width: 200px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedPrintQueueStatusSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedPrintQueueStatus"
					(ngModelChange)="onStatusChange($event)"
				>
					<option *ngFor="let r of lstPrintQueueStatus" [ngValue]="r">
						{{ r.IDDepotPrintQueueStatusDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 		  -->
	<!-- Comments -->
	<!-- 		  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Comment</label>
			</div>

			<div style="margin-left: 10px; width: 200px">
				<textarea rows="3" cols="35" pInputTextarea autoResize="autoResize" [(ngModel)]="Comment"></textarea>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
